<template>
  <div pr-hold-right>
    <div class="j" data-offset="0"></div>
    <div pr-hold-right-body class="stick-body" :style="bodyStyle">
      <div pr-hold-right-content :style="imageStyle">
        <slot />
      </div>
      <PrSplit type="type0" :img="img" :title="title" :push="push" :style="imageStyle" />
    </div>
  </div>
</template>

<script>
import PrSplit from "@/views/components/PrSplit";
import { applyRatio, getOffsetTop } from "@/utils";
import responsive from "@/utils/responsive";
export default {
  name: "PrHoldRight",
  components: { PrSplit },
  data() {
    return {
      bodyStyle: {},
      imageStyle: {},
      stickContainer: null,
      stickBody: null,
      push: 0,
      innerList: [],
      fixed: false,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    img: { type: String },
  },
  watch: {
    sv: "render",
  },
  methods: {
    inner(r) {
      this.push = r;
      applyRatio(this.innerList, r);
    },
    render() {
      if (!this.$el) return;
      const sv = this.sv;
      const d = sv - getOffsetTop(this.$el);
      const h = this.$el.offsetHeight * 0.5;
      if (d < 0 || d > h) {
        if (this.fixed) {
          this.$el.appendChild(this.stickBody);
          this.fixed = false;
          this.$store.commit("setFix", false);
        }
      } else {
        if (!this.fixed) {
          this.stickContainer.appendChild(this.stickBody);
          this.fixed = true;
          this.$store.commit("setFix", true);
        }
      }
      if (d < -window.innerHeight * 2 || d > window.innerHeight * 2) return;
      this.inner(d / h);

      const t = this.sect === "sm" || this.sect === "md" ? 55 : 64;
      const y = d > h ? h + t : t;
      const ih = h - t;

      this.bodyStyle = { paddingTop: t + "px" };
      this.imageStyle = { height: ih + "px", top: y + "px" };
    },
  },
  mounted() {
    this.stickContainer = document.querySelector(".stick-container");
    this.stickBody = this.$el.querySelector(".stick-body");
    responsive.addListener(this.render);
    this.innerList = this.$el.querySelectorAll(
      "[pr-hold-right-content] [data-p]"
    );
  },
  beforeDestroy() {
    responsive.removeListener(this.render);
    this.stickBody.parentNode.removeChild(this.stickBody);
    this.$store.commit("setFix", false);
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

[pr-hold-right] {
  .h(200vh);

  .j {
    .abs;
    .t(100vh);
  }
}

[pr-hold-right-body] {
  [pr-split] {
    .abs;
    .wf;
    .lt;

    .bg {
      background-position: 100% center;
    }
  }

  [pr-hold-right-content] {
    .abs;
    .lt;
    .w(50%);
  }
}
</style>
